import { useEffect } from 'react';
import { isAndroid } from 'shared/src/utils';
import type { OptionComponent } from 'shared/src/api';
import { retainedState, useRetainedState } from 'shared/src/hooks/retainedState';

type SelectedOptions = { [key: number]: OptionComponent };

const selectedOptionsState = retainedState<SelectedOptions>(() => ({}));

export const useSelectedOptions = () => {
  const [value, setValue] = useRetainedState(selectedOptionsState);

  useEffect(() => {
    // 웹은 visit 경계(Provider)가 없어 매 마운트 초기화. 네이티브는 retain 유지.
    if (!isAndroid) {
      setValue({});
    }
  }, [setValue]);

  return [value, setValue] as const;
};
